define('modules/home/sidebar/views/base.customizable.sidebar.view',[
    'client',
    'jquery',
    'underscore',
    'backbone',
    'marionette',
    'modules/base/views/model.view',
    'modules/base/models/user.setting.model',
    'text!modules/home/sidebar/templates/following.filters.template.html'
], function(
    Prospector,
    $,_,Backbone,
    Marionette,
    ModelView,
    UserSettingModel,
    FollowingFiltersTemplate
){
    var BaseCustomizableSidebarView = ModelView.extend({
        template: _.template(''),
        emptyTemplate: _.template(''),
        emptyResultsTemplate: _.template(''),
        followingFiltersTemplate: _.template(FollowingFiltersTemplate),
        firstLoad: true,
        className: 'baseCustomizableSidebarView',
        modelSelector: '.alertsHolder',
        filterSelector: '.searchBar',
        abortable: true,
        ascIcon: 'fa-sort-amount-asc',
        descIcon: 'fa-sort-amount-desc',
        numSettingsChanged: 0,
        saveDefaultsLabel: 'Make current options default',
        sortFieldIndex: 0,
        sortDirectionIndex: 0,
        followingFilterIndex: 0,
        monitoringFilterIndex: 0,
        refreshTrigger: '',
        requiredLength: 0,
        initialize:function (options) {
            Prospector.on(this.refreshTrigger, this.shouldRebuildFilters, this);
            ModelView.prototype.initialize.call(this, options);
        },
        buildModel:function(){
            this.model = new Backbone.Model();
        },
        mEvents:function(){
            return {
                'click .toggleFilters' : 'procToggleFilters',
                'click .toggleSort'    : 'procToggleSort',
                'click .setDefault'    : 'procSetDefault',
                'click .viewOptions'   : 'procViewOptions',
                'click .reset'         : 'procReset',
                'click .reset_icon'    : 'resetSearch',
                'change select'        : 'fetchModel'
            }
        },
        resetSearch:function() {
            this.$('.searchBar').val("");
            this.fetchModel();
        },
        shouldRebuildFilters:function (options) {
            if(options.className != this.className){
                this.buildSettings();
                this.fetchModel();
            }
        },
        onRender:function(){
            var fTemp = this.followingFiltersTemplate().replace(new RegExp('%followingType%', 'g'), 'Follow');
            var mTemp = this.followingFiltersTemplate().replace(new RegExp('%followingType%', 'g'), 'Monitor');
            this.$('.followingFilter').html(fTemp);
            this.$('.monitoringFilter').html(mTemp);
            if(!Prospector.SettingsApp.hasRoleMonitoring()){
                this.$('.hasMonitoring').remove();
                _.each(this.$('.sortField option'), function (e){
                    if($(e).html().toLowerCase().indexOf("monitoring") > -1){
                        $(e).remove();
                    }
                }, this);
            }


            this.$('.setDefault').html(this.saveDefaultsLabel);
            this.buildSettings();
            ModelView.prototype.onRender.call(this);
        },
        procReset:function(){
            this.$(this.filterSelector).val('');
            this.buildSettings();
            this.fetchModel();
        },
        buildSettings:function(){
            var profileSettings = window.user.get('userSettings')[1].userSettingsLevel1;
            this.settings = [];
            this.settings.push(this.createSettingsDropdown(profileSettings, this.sortFieldIndex, '.sortField'));
            //this.settings.push(this.createSettingsSortToggle(profileSettings, this.sortDirectionIndex, '.toggleSort .fa'));
            this.settings.push(this.createSettingsDropdown(profileSettings, this.followingFilterIndex, '.followingFilter'));
            if(Prospector.SettingsApp.hasRoleMonitoring()) {
                this.settings.push(this.createSettingsDropdown(profileSettings, this.monitoringFilterIndex, '.monitoringFilter'));
            }
        },
        createSettingsDropdown:function(profileSettings, index, dropdown){
            var setting = new UserSettingModel(profileSettings[index]);
            setting.type = "dropdown";
            setting.selector = dropdown;
            this.$(setting.selector).val(setting.get('value'));
            return setting;
        },
        createSettingsSortToggle:function(profileSettings, index, toggle){
            var setting = new UserSettingModel(profileSettings[index]);
            setting.type = "sortToggle";
            setting.selector = toggle;
            var icon = setting.get('value') == "asc" ? this.ascIcon : this.descIcon;
            this.$(setting.selector).removeClass(this.ascIcon).removeClass(this.descIcon).addClass(icon);
            return setting;
        },
        getSortOrder: function(){
            return this.$('.toggleSort .fa').hasClass(this.ascIcon) ? 'asc' : 'desc';
        },
        procSetDefault:function(){
            if(!this.$('.setDefault').hasClass('disabled')) {
                var changedSettings = this.getChangedSettings();
                if(changedSettings.length > 0){
                    this.$('.setDefault').addClass('disabled').html('Saving...');
                    this.numSettingsChanged = changedSettings.length;
                    _.each(changedSettings, function(s){
                        s.set({value: this.getSettingElementValue(s)});
                        this.listenTo(s, 'sync', this.procUpdateSettings, this);
                        s.save()
                    }, this);
                }
            }
        },
        getChangedSettings:function(){
            var changedSettings = [];
            _.each(this.settings, function(s){
                if(this.settingHasChanged(s)){
                    changedSettings.push(s);
                }
            }, this);
            return changedSettings;
        },
        getSettingElementValue:function(setting){
            var returnVal = undefined;
            switch (setting.type){
                case "dropdown":{
                    returnVal = this.$(setting.selector).val();
                    break;
                }
                case "sortToggle":{
                    returnVal = this.getSortOrder();
                }
            }
            return returnVal;
        },
        settingHasChanged:function(setting){
            var returnVal = false;
            switch (setting.type){
                case "dropdown":{
                    returnVal = this.$(setting.selector).val() != setting.get('value');
                    break;
                }
                case "sortToggle":{
                    returnVal = this.getSortOrder() != setting.get('value');
                }
            }
            return returnVal;
        },
        procUpdateSettings:function () {
            this.numSettingsChanged--;
            if(this.numSettingsChanged == 0){
                this.listenToOnce(window.user, 'sync', this.procUser, this);
                window.user.fetch();
            }
        },
        procUser:function(){
            Prospector.trigger(this.refreshTrigger, {className: this.className});
            this.$('.setDefault').html(this.saveDefaultsLabel).removeClass('disabled');
        },
        procToggleSort:function(){
            if(this.$('.toggleSort .fa').hasClass(this.ascIcon)){
                this.$('.toggleSort .fa').removeClass(this.ascIcon).addClass(this.descIcon);
            } else {
                this.$('.toggleSort .fa').removeClass(this.descIcon).addClass(this.ascIcon);
            }
            this.fetchModel();
        },
        procToggleFilters:function () {
            var display = this.$('.expandableFilters').css('display');
            if(display == "none"){
                this.$('.expandableFilters').slideDown();
                this.$('.viewOptions').show();
                this.$('.toggleFilters').html('Collapse filters and sorts');
            } else {
                this.$('.expandableFilters').slideUp();
                this.$('.viewOptions').hide();
                this.$('.toggleFilters').html('Expand filters and sorts');
            }
        },
        procViewOptions:function(){
            Prospector.trigger('loadLayout');
        },
        procResponse:function(){
        },
        addLoader:function(){
            if(this.isFirstLoad){
                ModelView.prototype.addLoader.call(this);
            } else {
                this.$(this.modelSelector).empty().append('<div></div><div></div>').addClass('ripple');
            }
        },
        fetchModel:function(){
            var changedSettings = this.getChangedSettings();
            var filter = this.getInputString();
            var display = this.$('.expandableFilters').css('display');

            if(changedSettings.length > 0 || filter.length > 0){
                this.$('.setDefault').show();
                this.$('.reset').show();
            } else {
                this.$('.setDefault').hide();
                this.$('.reset').hide();
            }

            this.model.followingFilter = this.$('.followingFilter').val();
            if(Prospector.SettingsApp.hasRoleMonitoring()) {
                this.model.monitoringFilter = this.$('.monitoringFilter').val();
            }
            var sorts = this.getSorts();
            this.model.sortField = sorts.sortField;
            this.model.sortOrder = sorts.sortOrder;
            this.model.query = filter;
            //this.model.sortOrder = this.$('.toggleSort .fa').hasClass(this.ascIcon)? 'asc' : 'desc';
            ModelView.prototype.fetchModel.call(this);
        },
        fetchModelNoLoader: function(){
            this.cleanMySubviews();
            this.model.page = 1;
            this.listenToOnce(this.model, 'sync', this.procModelNoLoader, this);
            if(this.abortable){
                if(this.currXHR != undefined && this.currXHR.readyState > 0 && this.currXHR.readyState < 4){
                    this.currXHR.abort();
                }
            }
            if(this.mode == 'fetch'){
                this.currXHR = this.model.fetch();
            } else
            if(this.mode == 'save'){
                this.currXHR = this.model.save();
            }
        },
        procModelNoLoader:function(){
            if(this.model.has('error')){
                this.errOut(this.model.get('error').message);
                this.model.set({error: undefined});
            }else {
              //  Prospector.trigger('refreshedFollowing');
            }
        },
        getSorts:function(){
            var sortField = this.$('.sortField').val();
            var sortOrder = 'desc';

            if(sortField.indexOf('Desc') > -1){
                sortField = sortField.substring(0, sortField.length - 4);
            } else if(sortField.indexOf('Asc') > -1){
                sortOrder = 'asc';
                sortField = sortField.substring(0, sortField.length - 3);
            }

            return {
                sortOrder: sortOrder,
                sortField: sortField
            };
        }
    });
    return BaseCustomizableSidebarView;
});

